module.exports = __webpack_public_path__ + "assets/img/36_557_big.964a23a9.jpg";